import { Notification, NotificationAction } from '@app/components/various/Notification';
import { useAccountFormSettings } from '@app/services/hooks/account/useAccountFormSettings';
import { isDefined } from '@app/utils/is';
import { useTranslation } from 'react-i18next';

import { CreateAccountFormContent } from './CreateAccountFormContent';
import { CreateAccountFormSkeleton } from './CreateAccountFormSkeleton';

interface Props {
  onCancel: () => void;
  onSuccess?: () => void;
}

export const CreateAccountForm = ({ onCancel, onSuccess }: Props) => {
  const { data, isLoading, refetch } = useAccountFormSettings();
  const { t } = useTranslation(['accounts', 'common']);

  if (isLoading) {
    return <CreateAccountFormSkeleton />;
  }

  if (isDefined(data)) {
    return <CreateAccountFormContent onCancel={onCancel} onSuccess={onSuccess} formSettings={data} />;
  }

  return (
    <Notification type="error" isBordered message={t('accounts:account_form_error')}>
      <NotificationAction onClick={async () => refetch()}>{t('common:reload')}</NotificationAction>
    </Notification>
  );
};
